import React, { useState, useEffect } from "react";
import { Layout, Menu, Card } from "antd";
import { motion, AnimatePresence } from "framer-motion";
import pose from "../../Assets/variation/pose.jpg";
import { API_BASE_URL } from "../../Config";
import AdvertisementCard from "../AdvertisementCard";

const { Sider, Content } = Layout;

const Breathe = () => {
  const [allYogaPages, setAllYogaPages] = useState([]);
  const [selectedKey, setSelectedKey] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAllYoga = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/allpages?page=breathe-technique`);
        const json = await res.json();
        const pages = json?.data || [];
        setAllYogaPages(pages);
        // Auto-select first page if available
        if (pages.length > 0) setSelectedKey(pages[0]._id);
      } catch (error) {
        console.error("API Fetch Error", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllYoga();
  }, []);

  const getCurrentContent = () => {
    if (!selectedKey) return "<p>No content found.</p>";
    return allYogaPages.find((p) => p._id === selectedKey)?.content || "<p>No content found.</p>";
  };

  const menuItems = allYogaPages.map((p) => ({
    key: p._id,
    label: p.yogaType,
  }));

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "30px 10px",
        minHeight: "100vh",
        background: "#f0f2f5",
      }}
    >
      <Layout
        className="responsive"
        style={{
          width: "90%",
          maxWidth: "1200px",
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          display: "flex",
          overflow: "hidden",
        }}
      >
        <Sider
          className="sub_slider"
          width={250}
          style={{
            height: "900px",
            backgroundImage: `url(${pose})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
          }}
        >
          <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.6)" }} />
          <div
            style={{
              position: "relative",
              zIndex: 2,
              padding: "16px",
              fontWeight: "bold",
              textAlign: "center",
              color: "#fff",
            }}
          >
            Breathe Techniques
          </div>

          {loading ? (
            <p style={{ color: "#fff", textAlign: "center", position: "relative", zIndex: 2 }}>
              Loading...
            </p>
          ) : (
            <Menu
              theme="white"
              mode="inline"
              style={{
                background: "transparent",
                color: "#ffffffA2",
                fontSize: "1.1rem",
                position: "relative",
                zIndex: 2,
                fontWeight: 500,
                textAlign: "center",
              }}
              onClick={(e) => setSelectedKey(e.key)}
              selectedKeys={selectedKey ? [selectedKey] : []}
              items={menuItems}
            />
          )}
        </Sider>

        <Content className="content_responsive" style={{ padding: "30px" }}>
          {loading ? (
            <h2>Loading...</h2>
          ) : allYogaPages.length === 0 ? (
            <Card style={{ borderRadius: "12px", padding: "24px" }}>
              <p style={{ textAlign: "center", color: "#999" }}>
                No content added yet. Please add breathe-technique pages from the admin panel.
              </p>
            </Card>
          ) : (
            <AnimatePresence mode="wait">
              <motion.div
                key={selectedKey}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4 }}
              >
                <Card
                  className="inner_card"
                  style={{ borderRadius: "12px", padding: "24px" }}
                >
                  <div
                    className="page-content"
                    dangerouslySetInnerHTML={{ __html: getCurrentContent() }}
                  />
                </Card>
              </motion.div>
            </AnimatePresence>
          )}
        </Content>
      </Layout>
      <AdvertisementCard />
    </motion.div>
  );
};

export default Breathe;